
import Logo from '@/assets/icons/gsm_droplet_monochrome.svg?inline'

export default {
  name: 'Header',

  components: {
    Logo,
  },

  methods: {
    onBurgerClick(e) {
      if (document.body.classList.contains('menuopen')) {
        document.body.classList.remove('menuopen')
      } else {
        document.body.classList.add('menuopen')
      }
    },
  },
}
